<template>
  <div class="mt-3">
    <div class="text-28 text-bold">
      {{$t("flexben.clients.client_general_config_titles")}}
    </div>
    <div class="container-bg-white mt-2">
      <div class="row px-3 pt-3">
        <div class="col-12 col-md-6 col-lg-4">
          <label for="last_order_days" class="col-form-label pt-0 cursor-pointer">
            {{$t("flexben.clients.partial.last_order_days")}}
          </label>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 form-group mb-1" :class="{'pb-3':!isAdmin}">
        <div class="d-flex flex-row align-items-center">
          <select class="form-control" id="last_order_days" v-model="generalClientSettings.last_monthly_order_day">
            <option v-for="(option, index) of last_order_days"
                    :value="option.val" :key="index">{{ option.text }}
            </option>
          </select>

          <span id="top_up_dejun_information"
                class="d-inline-block flexben-tooltip-icon ml-2 text-bold">i</span>
          <b-tooltip :target="'top_up_dejun_information'" variant="flexben" placement="topleft">
            <div v-html="$t('flexben.clients.errors.general_last_top_up_day_greater_then_up_dejun')"
                 class="text-left"></div>
          </b-tooltip>
        </div>
      </div>

      <div class="row px-3 pt-3">
        <div class="col-12 col-md-6 col-lg-4">
          <label for="order_cancelation_status" class="col-form-label pt-0 cursor-pointer">
            {{$t("flexben.clients.partial.order_cancelation_status")}}
          </label>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 form-group mb-1" :class="{'pb-3':!isAdmin}">
        <div class="d-flex flex-row align-items-center">
          <select v-if="isAdmin" class="form-control" id="order_cancelation_status"
                  v-model="generalClientSettings.order_cancelation_status">
            <option v-for="(option, index) of formOptions.order_cancelation_status_options"
                    :value="option" :key="index">{{ $t('flexben.requests.summary.status.' + option)}}
            </option>

          </select>
          <input v-else :value="$t('flexben.requests.summary.status.' + generalClientSettings.order_cancelation_status)"
                 class="form-control" disabled>
        </div>
      </div>

      <div class="row px-3 pb-3" v-if="isAdmin">
        <div class="col-12 d-flex">
          <label for="cam_budget_taxation" class="col-form-label mr-4 p-0 cursor-pointer">
            {{$t("flexben.clients.partial.cam_budget_taxation")}}
          </label>
          <b-form-checkbox id="cam_budget_taxation" class="d-inline-block cursor-pointer"
                           switch
                           v-model="generalClientSettings.cam_budget_taxation">
          </b-form-checkbox>
        </div>
        <div class="col-12 d-flex mt-2">
          <label for="gross_budget_taxation" class="col-form-label mr-4 p-0">
            {{$t("flexben.clients.partial.gross_budget_taxation")}}
          </label>
          <b-form-checkbox id="gross_budget_taxation" class="d-inline-block"
                           switch
                           v-model="generalClientSettings.gross_budget_taxation">
          </b-form-checkbox>
        </div>
        <div class="col-12 d-flex mt-2">
          <label for="legislated_gross_calculation" class="col-form-label mr-4 p-0 cursor-pointer">
            {{$t("flexben.clients.partial.legislated_gross_calculation")}}
          </label>
          <b-form-checkbox id="legislated_gross_calculation" class="d-inline-block cursor-pointer"
                           :disabled="!generalClientSettings.gross_budget_taxation"
                           switch
                           v-model="generalClientSettings.legislated_gross_calculation">
          </b-form-checkbox>
        </div>

        <div class="col-12 d-flex mt-2">
          <label for="annual_budget_reset" class="col-form-label mr-4 p-0 cursor-pointer">
            {{$t("flexben.clients.partial.annual_budget_reset")}}
          </label>
          <b-form-checkbox id="annual_budget_reset" class="d-inline-block cursor-pointer"
                           switch
                           v-model="generalClientSettings.annual_budget_reset">
          </b-form-checkbox>
        </div>

        <div class="col-12 d-flex mt-2">
          <label for="budget_telework_transfer_to_general" class="col-form-label mr-4 p-0 cursor-pointer">
            {{$t("flexben.clients.partial.budget_telework_transfer_to_general")}}
          </label>
          <b-form-checkbox id="budget_telework_transfer_to_general" class="d-inline-block cursor-pointer"
                           switch
                           v-model="generalClientSettings.budget_telework_transfer_to_general">
          </b-form-checkbox>
        </div>
        <div class="col-12 d-flex mt-2">
          <label for="non_legislated_net_taxes_calculate" class="col-form-label mr-4 p-0 cursor-pointer">
            {{$t("flexben.clients.partial.non_legislated_net_taxes_calculate")}}
          </label>
          <b-form-checkbox id="non_legislated_net_taxes_calculate" class="d-inline-block cursor-pointer"
                           switch
                           v-model="generalClientSettings.non_legislated_net_taxes_calculate">
          </b-form-checkbox>
        </div>
        <div class="col-12 d-flex mt-2">
          <label for="top_up_live" class="col-form-label mr-4 p-0 cursor-pointer">
            {{$t("flexben.clients.partial.top_up_live")}}
          </label>
          <b-form-checkbox id="top_up_live" class="d-inline-block cursor-pointer"
                           :disabled="!isAdmin"
                           switch
                           v-model="generalClientSettings.top_up_live">
          </b-form-checkbox>
        </div>
        <div class="col-12 col-md-6 col-lg-4 form-group mb-1 mt-2">
          <label for="cash_out_last_order_day" class="col-form-label mr-4 p-0">
            {{$t("flexben.clients.partial.cash_out_last_order_day")}}
          </label>
          <div>
            <select v-model="generalClientSettings.cash_out_last_order_day"
                    id="cash_out_last_order_day" class="form-control">
              <option v-for="day of generateRange(5, 25)" :value="day" :key="day">{{ day }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row px-3 pb-3">
        <div class="col-12 col-md-6 col-lg-4 form-group mb-1 mt-2 d-flex flex-column">
          <label for="non_legislated_benefit_invoice_enabled" class="col-form-label mr-4 p-0 cursor-pointer">
            {{$t("flexben.clients.partial.non_legislated_benefit_invoice_enabled")}}
          </label>
          <div class="d-flex mt-3">
            <span>{{ $t('flexben.general.disable') }}</span>
            <b-form-checkbox id="non_legislated_benefit_invoice_enabled" class="cursor-pointer ml-2 mr-3"
                             switch
                             v-model="non_legislated_benefit_invoice_enabled">
            </b-form-checkbox>
            <span>{{ $t('flexben.general.enable') }}</span>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 form-group mb-1 mt-2">
          <label for="non_legislated_benefit_invoice_day" class="col-form-label mr-4 p-0">
            {{$t("flexben.clients.partial.non_legislated_benefit_invoice_day")}}
          </label>
          <div>
            <select :disabled="!non_legislated_benefit_invoice_enabled"
                    v-model="generalClientSettings.non_legislated_benefit_invoice_day"
                    id="non_legislated_benefit_invoice_day" class="form-control">
              <option v-for="day of generateRange(1, 25)" :value="day" :key="day">{{ day }}</option>
            </select>
          </div>
        </div>
        <hr>
      </div>
      <div class="row px-3 pb-3">
        <div class="col-12 d-flex align-items-center">
          <label for="banner_image" class="col-form-label mr-4 p-0 text-24">
            {{$t("flexben.clients.partial.banner")}}
          </label>
          <div class="col-12 text-danger"
               :class="{'d-none':bannerImageError===null}">{{ bannerImageError }}
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center align-items-start mt-3 mb-3">
          <div class="image-container-1000 d-flex cursor-pointer d-flex align-items-center"
               @click="$refs.bannerImage.click()">
            <div class="image-changed w-100" v-if="image_changed">{{$t("flexben.general.image_changed")}}</div>
            <img class="img-fluid cursor-pointer upload-image"
                 :class="{'img-border-danger':(Object.keys(errors_bag).includes('image'))}"
                 :src="(bannerImage !== null) ? image_preview : generalClientSettings.banner_image_url"/>
            <div class="upload-image-middle-container mx-auto">
              <div class="upload-image-text">{{$t("flexben.general.upload_image")}}</div>
            </div>
            <input type="file" class="hide" ref="bannerImage" accept=".png,.jpeg,.jpg,.svg,.jfif"
                   id="banner_image"
                   @change="setImageFile($event)">
          </div>
        </div>
      </div>
    </div>
    <div v-if="isAdmin" class="text-28 text-bold mt-3 mb-2">{{$t("flexben.clients.module_permission")}}</div>

    <div v-if="isAdmin" class="container-bg-white mt-2">
      <div class="row px-3 pt-3">
        <div class="col-12 col-md-6">
          <div v-for="(item, index) of generalClientSettings.company_module_permissions" :key="index"
               class="d-flex" :class="{'my-3':index!==0}">
            <label :for="item.module_permission.code" class="col-form-label mr-4 p-0 cursor-pointer">
              {{ item.module_permission.name[locale] }}:
            </label>
            <div class="d-flex">
              <span>{{ $t('flexben.general.no') }}</span>
              <b-form-checkbox :id="item.module_permission.code"
                               class="mx-3"
                               switch
                               :disabled="!generalClientSettings.module_permissions_editable"
                               v-model="item.status">
              </b-form-checkbox>
              <span>{{ $t('flexben.general.yes') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {BFormCheckbox, BTooltip} from "bootstrap-vue";
import i18n from "@/plugins/language/i18n";

export default {
  components: {
    "b-form-checkbox": BFormCheckbox,
    "b-tooltip": BTooltip,
  },
  name: "ClientGeneralSettings",
  props: {
    isAdmin: {
      type: Boolean,
      required: true,
      default: false
    },
    client: {
      type: Object,
      required: true
    },
    formOptions: {
      order_cancelation_status_options: []
    },
    generalClientSettings: {
      type: Object,
      required: true,
      default: function () {
        return {
          cam_budget_taxation: false,
          legislated_gross_calculation: false,
          gross_budget_taxation: false,
          annual_budget_reset: false,
          use_telework_budget: false,
          last_monthly_order_day: null,
          non_legislated_benefit_invoice_enabled: false,
          non_legislated_benefit_invoice_day: null,
          banner_image_url: null,
          company_module_permissions: [],
          module_permissions_editable: false,
          top_up_live: false,
          type: null,
          type_code: null,
          non_legislated_net_taxes_calculate: false
        };
      }
    },
    bannerImage: {
      default: null
    },
    bannerImageUrl: {
      default: null
    },
  },
  data: function () {
    return {
      non_legislated_benefit_invoice_enabled: false,
      image_changed: false,
      image_preview: null,
      bannerImageError: null,
      errors_bag: {},
      locale: i18n.locale
    };
  },
  computed: {
    last_order_days: function () {
      let options = [
        {val: null, text: this.$t('flexben.general.disabled')}
      ];
      let option;
      for (let i = 1; i <= 31; i++) {
        option = {val: i, text: i};
        options.push(option);
      }
      option = null;

      return options;
    },
    cash_out_days: function () {
      let options = [];
      let option;
      for (let i = 5; i <= 25; i++) {
        option = {val: i, text: i};
        options.push(option);
      }
      option = null;

      return options;
    },
  },
  watch: {
    'generalClientSettings.banner_image_url': function (newVal, oldVal) {
      this.image_changed = false;
    },
    'generalClientSettings.gross_budget_taxation': function (val) {
      if (!val) {
        this.generalClientSettings.legislated_gross_calculation = false;
      }
    },
    deep: true,
    non_legislated_benefit_invoice_enabled: function (val) {
      this.$parent.formData.client_settings.non_legislated_benefit_invoice_enabled = val;
    }
  },
  methods: {
    setImageFile() {
      this.errors_bag = {};
      if (this.$refs.bannerImage.accept.indexOf(this.$refs.bannerImage.files[0].type.split('/')[1]) > 0) {
        let reader = new FileReader();
        reader.readAsDataURL(this.$refs.bannerImage.files[0]);
        reader.onload = evt => {
          let img = new Image();
          img.onload = () => {
            if (img.width !== 1018 || img.height !== 166) {
              this.bannerImageError = this.$t('flexben.formErrorReasons.image_1018_166');
            } else {
              this.$parent.formData.bannerImage = this.$refs.bannerImage.files[0];
              this.bannerImageError = null;
              this.image_changed = true;
              if (typeof this.$parent.formData.bannerImage !== "undefined") {
                this.image_preview = URL.createObjectURL(this.$parent.formData.bannerImage);
              }
            }
          }
          img.src = evt.target.result;
        }
      } else {
        this.errors_bag = {image: 'image_type_supported'}
      }
    }
  },
  created() {
    this.non_legislated_benefit_invoice_enabled = this.$parent.formData.client_settings.non_legislated_benefit_invoice_enabled;
  }
}
</script>
